module.exports = __webpack_public_path__ + "static/mason-jar-coloring-page-26bdcba47c83b78350e81c5ae5cc20af.pdf";